module.exports = __webpack_public_path__ + "img/lg_ring_y_o_0_null@2x.c56c1403.png";